var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhoneNew = function SvgPhoneNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A2550",
    d: "M9.084.666H2.918A2.31 2.31 0 0 0 .609 2.974v12.05a2.31 2.31 0 0 0 2.309 2.309h6.166a2.31 2.31 0 0 0 2.309-2.309V2.974A2.31 2.31 0 0 0 9.084.666",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A2550",
    d: "M3.459 4.533a.933.933 0 1 0 0-1.867.933.933 0 0 0 0 1.867"
  })));
};
export default SvgPhoneNew;